import { render, staticRenderFns } from "./CardHolders.vue?vue&type=template&id=3da06012&scoped=true"
import script from "./CardHolders.vue?vue&type=script&lang=js"
export * from "./CardHolders.vue?vue&type=script&lang=js"
import style0 from "./CardHolders.vue?vue&type=style&index=0&id=3da06012&prod&lang=scss&scoped=true"
import style1 from "./CardHolders.vue?vue&type=style&index=1&id=3da06012&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da06012",
  null
  
)

export default component.exports